import { UserApiUserUpdateRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const useUserUpdateMutation = () =>
  useBaseMutation({
    mutationFn: (req: UserApiUserUpdateRequest, config) =>
      appApiClient.userApi.userUpdate(req, config),
  });
